<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

import defaultQueries from '@/assets/data/queries/default_queries.json'

export default {
  name: 'App',
  components: {},
  mounted () {
    if (!localStorage.queries) {
      localStorage.queries = JSON.stringify(defaultQueries);
    }
  }
}

</script>